import React from 'react';
import {useState,useEffect,Component} from 'react';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';





/* Import home from File */





import Home from './home.js';
import Adminlogin from './Admin/login.js';
import Customerlogin from './Customers/login.js';
import Employeelogin from './Employees/login.js';
import Admin_cash from './Admin/Admin_cash.js';
import Admin_bank from './Admin/Admin_bank.js';
import Admin_customers from './Admin/Admin_customers.js';
import Admin_newaccounts from './Admin/Admin_newaccounts.js';
import Admin_incomes from './Admin/Admin_incomes.js';
import Admin_expenses from './Admin/admin_expenses.js';
import Admin_employees from './Admin/Admin_employees.js';
import Admin_loanpayments from './Admin/Admin_loanpayments.js';
import Admin_loanrequests from './Admin/Admin_loanrequests.js';
import Employee_cash from './Employees/Employee_cash.js';
import Employee_bank from './Employees/Employee_bank.js';
import Employee_customers from './Employees/Employee_customers.js';
import Employee_newaccounts from './Employees/Employee_newaccounts.js';
import Employee_incomes from './Employees/Employee_incomes.js';
import Employee_expenses from './Employees/Employee_expenses.js';
import Employee_loanpayments from './Employees/Employee_loanpayments.js';
import Employee_loanrequests from './Employees/Employee_loanrequests.js';
import Employee_add_customer from './Employees/Employee_add_customer.js';
import Employee_edit_customer from './Employees/Employee_edit_customer.js';
import Employee_customer_profile from './Employees/Employee_customer_profile.js';
import Employee_customer_loans from './Employees/Employee_customer_loans.js';
import Employee_create_cash from './Employees/Employee_create_cash.js';
import Employee_create_bank from './Employees/Employee_create_bank.js';
import Employee_create_expense from './Employees/Employee_create_expense.js';
import Employee_create_income from './Employees/Employee_create_income.js';
import Employee_edit_cash from './Employees/Employee_edit_cash.js';
import Employee_edit_bank from './Employees/Employee_edit_bank.js';
import Employee_edit_expense from './Employees/Employee_edit_expense.js';
import Employee_edit_income from './Employees/Employee_edit_income.js';
import Admin_create_cash from './Admin/Admin_create_cash.js';
import Admin_edit_cash from './Admin/Admin_edit_cash.js';
import Admin_create_bank from './Admin/Admin_create_bank.js';
import Admin_edit_bank from './Admin/Admin_edit_bank.js';
import Admin_create_expense from './Admin/Admin_create_expense.js';
import Admin_edit_expense from './Admin/Admin_edit_expense.js';
import Admin_create_income from './Admin/Admin_create_income.js';
import Admin_edit_income from './Admin/Admin_edit_income.js';
import Admin_customer_profile from './Admin/Admin_customer_profile.js';
import Admin_loanschemes from './Admin/Admin_loanschemes.js';
import Admin_create_loanscheme from './Admin/Admin_create_loanscheme.js';
import Admin_edit_loanscheme from './Admin/Admin_edit_loanscheme.js';
import Employee_loanschemes from './Employees/Employee_loanschemes.js';
import Employee_customer_updations from './Employees/Employee_customer_updations.js';
import Admin_customer_updations from './Admin/Admin_customer_updations.js';
import Admin_transaction_history from './Admin/Admin_transaction_history.js';
import Employee_transaction_history from './Employees/Employee_transaction_history.js';
import Admin_branch from './Admin/Admin_branch.js';
import Admin_create_branch from './Admin/Admin_create_branch.js';
import Admin_edit_branch from './Admin/Admin_edit_branch.js';
import Admin_employee_profile from './Admin/Admin_employee_profile.js';
import Admin_add_employee from './Admin/Admin_add_employee.js';
import Admin_edit_employee from './Admin/Admin_edit_employee.js';
import Admin_employee_salary from './Admin/Admin_employee_salary.js';
import Admin_create_salary from './Admin/Admin_create_salary.js';
import Admin_edit_salary from './Admin/Admin_edit_salary.js';
import Employee_loan_application from './Employees/Employee_loan_application.js';
import Employee_customer_emis from './Employees/Employee_customer_emis.js';
import Admin_customer_loans from './Admin/Admin_customer_loans.js';
import Admin_customer_emis from './Admin/Admin_customer_emis.js';
import Customer_customer_profile from './Customers/Customer_customer_profile.js';
import Customer_customer_loans from './Customers/Customer_customer_loans.js';
import Customer_customer_emis from './Customers/Customer_customer_emis.js';
import Customer_dashboard from './Customers/Customer_dashboard.js';
import Admin_loan_scheme_details from './Admin/Admin_loan_scheme_details.js';
import Admin_add_bank from './Admin/Admin_add_bank.js';
import Admin_edit_customer from './Admin/Admin_edit_customer.js';
import Admin_view_customer_application from './Admin/Admin_view_customer_application.js';
import Employee_view_loan_application from './Employees/Employee_view_loan_application.js';
import Admin_view_loan_application from './Admin/Admin_view_loan_application.js';
import Admin_loan_approval from './Admin/Admin_loan_approval.js';
import Employee_pay_emi from './Employees/Employee_pay_emi.js';
import Home1 from './home1.js';
import Customer_customer_updations from './Customers/Customer_customer_updations.js';
import Customer_customer_emis_history from './Customers/Customer_emis_history.js';
import Admin_view_salary from './Admin/Admin_view_salary.js';
import Admin_view_emi from './Admin/Admin_view_emi.js';
import Employee_view_emi from './Employees/Employee_view_emi.js';
import Employee_loan_closure from './Employees/Employee_loan_closure.js';
import Employee_closure_requests from './Employees/Employee_closure_requests.js';
import Employee_view_closure from './Employees/Employee_view_closure.js';
import Admin_closure_requests from './Admin/Admin_closure_requests.js';
import Admin_view_closure from './Admin/Admin_view_closure.js';
import Admin_offer_letter from './Admin/Admin_offer_letter.js';
import Admin_create_offer_letter from './Admin/Admin_create_offer_letter.js';
import Admin_manage_employee_permissions from './Admin/Admin_manage_employee_permissions.js';
import Admin_cust_lp from './Admin/Admin_cust_lp.js';
import Employee_drive1 from './Employees/Employee_drive1.js';
import Admin_offerletters_history from './Admin/Admin_offerletters_history.js';
import Employee_customer_emicard from './Employees/Employee_customer_emicard.js';
import Admin_customer_emicard from './Admin/Admin_customer_emicard.js';
import Admin_loandisbursals from './Admin/Admin_loandisbursals.js';
import Employee_loandisbursals from './Employees/Employee_loandisbursals.js';
import Employee_disbursalcollection from './Employees/Employee_disbursalcollection.js';
import Admin_edit_emi from './Admin/Admin_edit_emi.js';
import Employee_loan_scheme_details from './Employees/Employee_loan_scheme_details.js';
import Admin_headers from './Admin/Admin_headers.js';
import Admin_create_header from './Admin/Admin_create_header.js';
import Employee_part_payment from './Employees/Employee_part_payment.js';
import Employee_partpayment_requests from './Employees/Employee_partpayment_requests.js';
import Employee_view_partpayment from './Employees/Employee_view_partpayment.js';
import Admin_view_partpayment from './Admin/Admin_view_partpayments.js';
import Admin_partpayment_requests from './Admin/Admin_partpayment_requests.js';
import Admin_collections from './Admin/Admin_collections.js';
import Employee_collections from './Employees/Employee_collections.js';
import Admin_transaction_approvals from './Admin/Admin_transaction_approvals.js';
import Admin_loan_noc from './Admin/Admin_loan_noc.js';
import Employee_loan_noc from './Employees/Employee_loan_noc.js';
import Admin_loangroups from './Admin/Admin_loangroups.js';
import Admin_group_loanrequests from './Admin/Admin_group_loanrequests.js';
import Employee_loangroups from './Employees/Employee_loangroups.js';
import Employee_group_loanrequests from './Employees/Employee_group_loanrequests.js';
import Admin_finalanalysis from './Admin/Admin_finalanalysis.js';
import Admin_branch_finalanalysis from './Admin/Admin_branch_finalanalysis.js';
import Admin_employee_finalanalysis from './Admin/Admin_employee_finalanalysis.js';
import Admin_fd_schemes from './Admin/Admin_fd_schemes.js';
import Admin_create_fdscheme from './Admin/Admin_createfd_scheme.js';
import Admin_fd_scheme_details from './Admin/Admin_fd_scheme_details.js';
import Admin_edit_fdscheme from './Admin/Admin_edit_fdscheme.js';
import Employee_fd_schemes from './Employees/Employee_fd_schemes.js';
import Employee_fd_scheme_details from './Employees/Employee_fd_scheme_details.js';
import Employee_fd_application from './Employees/Employee_fd_application.js';
import Employee_fd_requests from './Employees/Employee_fd_requests.js';
import Employee_view_fd_application from './Employees/Employee_view_fd_application.js';
import Admin_fd_requests from './Admin/Admin_fd_requests.js';
import Admin_view_fd_application from './Admin/Admin_view_fd_application.js';
import Admin_fixed_deposits from './Admin/Admin_fixed_deposits.js';
import Employee_fixed_deposits from './Employees/Employee_fixed_deposits.js';
import Admin_view_fixed_deposit from './Admin/Admin_view_fixed_deposit.js';
import Employee_view_fixed_deposit from './Employees/Employee_view_fixed_deposit.js';
import Employee_fd_withdrawal from './Employees/Employee_fd_withdrawal.js';
import Employee_fd_withdrawals from './Employees/Employee_fd_withdrawals.js';
import Employee_view_fd_withdrawal from './Employees/Employee_view_fd_withdrawal.js';
import Admin_fd_withdrawals from './Admin/Admin_fd_withdrawals.js';
import Admin_view_fd_withdrawal from './Admin/Admin_view_fd_withdrawal.js';
import Admin_approve_fd_withdrawal from './Admin/Admin_approve_fd_withdrawal.js';
import Employee_test_emp_adr from './Employees/Employee_test_emp_adr.js';
import Admin_rd_schemes from './Admin/Admin_rd_schemes.js';
import Admin_create_rdscheme from './Admin/Admin_createrd_scheme.js';
import Admin_rd_scheme_details from './Admin/Admin_rd_scheme_details.js';
import Admin_edit_rdscheme from './Admin/Admin_edit_rdscheme.js';
import Employee_rd_schemes from './Employees/Employee_rd_schemes.js';
import Employee_rd_scheme_details from './Employees/Employee_rd_scheme_details.js';
import Admin_rd_maturityamt_calculator from './Admin/Admin_rd_maturityamt_calculator.js';
import Employee_rd_maturityamt_calculator from './Employees/Employee_rd_maturityamt_calculator.js';
import Employee_rd_requests from './Employees/Employee_rd_requests.js';
import Employee_rd_application from './Employees/Employee_rd_application.js';
import Employee_view_rd_application from './Employees/Employee_view_rd_application.js';
import Admin_rd_requests from './Admin/Admin_rd_requests.js';
import Admin_view_rd_application from './Admin/Admin_view_rd_application.js';
import Employee_recurring_deposits from './Employees/Employee_recurring_deposits.js';
import Employee_view_recurring_deposit from './Employees/Employee_view_recurring_deposit.js';
import Admin_recurring_deposits from './Admin/Admin_recurring_deposits.js';
import Admin_view_recurring_deposit from './Admin/Admin_view_recurring_deposit.js';
import Employee_installmentpayments from './Employees/Employee_installmentpayments.js';
import Admin_installmentpayments from './Admin/Admin_installmentpayments.js';
import Employee_view_installment from './Employees/Employee_view_installment.js';
import Admin_view_installment from './Admin/Admin_view_installment.js';
import Employee_pay_rd_installment from './Employees/Employee_pay_rd_installment.js';
import Employee_fd_calculator from './Employees/Employee_fd_calculator.js';
import Admin_fd_calculator from './Admin/Admin_fd_calculator.js';
import Employee_rd_withdrawal from './Employees/Employee_rd_withdrawal.js';
import Employee_rd_withdrawals from './Employees/Employee_rd_withdrawals.js';
import Employee_view_rd_withdrawal from './Employees/Employee_view_rd_withdrawal.js';
import Admin_rd_withdrawals from './Admin/Admin_rd_withdrawals.js';
import Admin_view_rd_withdrawal from './Admin/Admin_view_rd_withdrawal.js';
import Admin_approve_rd_withdrawal from './Admin/Admin_approve_rd_withdrawal.js';
import Employee_finalanalysis from './Employees/Employee_finalanalysis.js';
import Admin_oddues from './Admin/Admin_oddues.js';
import Employee_oddues from './Employees/Employee_oddues';
import Employee_topup_loanclosure from './Employees/Employee_topup_loanclosure.js';
import Employee_topup_loan_closure_requests from './Employees/Employee_topup_loan_closure_requests.js';
import Admin_topup_loan_closure_requests from './Admin/Admin_topup_loan_closure_requests.js';
import Employee_loan_topup from './Employees/Employee_loan_topup.js';
import Employee_topup_loan_requests from './Employees/Employee_topup_loan_requests.js';
import Admin_topup_loan_requests from './Admin/Admin_topup_loan_requests.js';
import Admin_settings from './Admin/Admin_settings.js';
import Admin_newoddues from './Admin/Admin_newoddues.js';
import Employee_new_oddues from './Employees/Employee_new_oddues.js';
import Employee_loan_application_prefill from './Employees/Employee_loan_application_prefill.js';
import Admin_loangroupslist from './Admin/Admin_loangroupslist.js';
import Admin_create_group from './Admin/Admin_create_group.js';
import Admin_daysummary from './Admin/Admin_daysummary.js';
import Admin_daysummarylist from './Admin/Admin_daysummarylist.js';
import Employee_daysummarylist from './Employees/Employee_daysummarylist.js';
import Employee_daysummary from './Employees/Employee_daysummary.js';
import Employee_day_cash from './Employees/Employee_day_cash.js';
import Employee_dashboard from './Employees/Employee_dashboard.js';
import Employee_daily_collections from './Employees/Employee_daily_collections.js';
import Admin_daily_collections from './Admin/Admin_daily_collections.js';
import Employee_pay_collection from './Employees/Employee_pay_collection.js';
import Superadmin_transaction_approvals from './Admin/Superadmin_transaction_approvals.js';
import Admin_dashboard from './Admin/Admin_dashboard.js';
import Admin_loanscheme_calculator from './Admin/Admin_loanscheme_calculator.js';


function Routestosite(){

    return(
<>
<Router>
   <Routes>

   <Route exact path='/home' element={<Home1 />} />
   <Route exact path='/' element={<Home1 />} />

   <Route exact path='/home1' element={<Home />} />


   /* PRAGATI PRATHMIK SAKH SAHKARI SAMITI MARYADIT  LOAN CRM */


   /* ADMIN PANEL */
   <Route exact path='/adminpanel-login' element={<Adminlogin />} />
   <Route exact path='/adminpanel-dashboard-cash' element={<Admin_cash />} />
   <Route exact path='/adminpanel-dashboard-customers' element={<Admin_customers />} />
   <Route exact path='/adminpanel-dashboard-new-account-requests' element={<Admin_newaccounts />} />
   <Route exact path='/adminpanel-dashboard-add-bank' element={<Admin_add_bank />} />
   <Route exact path='/adminpanel-dashboard-bank' element={<Admin_bank />} />
   <Route exact path='/adminpanel-dashboard-incomes' element={<Admin_incomes />} />
   <Route exact path='/adminpanel-dashboard-expenses' element={<Admin_expenses />} />
   <Route exact path='/adminpanel-dashboard-employees' element={<Admin_employees />} />
   <Route exact path='/adminpanel-dashboard-loan-payments' element={<Admin_loanpayments />} />
   <Route exact path='/adminpanel-dashboard-loan-requests' element={<Admin_loanrequests />} />
   <Route exact path='/adminpanel-dashboard-create-cash' element={<Admin_create_cash />} />
   <Route exact path='/adminpanel-dashboard-edit-cash' element={<Admin_edit_cash />} />
   <Route exact path='/adminpanel-dashboard-create-bank' element={<Admin_create_bank />} />
   <Route exact path='/adminpanel-dashboard-edit-bank' element={<Admin_edit_bank />} />
   <Route exact path='/adminpanel-dashboard-create-expense' element={<Admin_create_expense />} />
   <Route exact path='/adminpanel-dashboard-edit-expense' element={<Admin_edit_expense />} />
   <Route exact path='/adminpanel-dashboard-create-income' element={<Admin_create_income />} />
   <Route exact path='/adminpanel-dashboard-edit-income' element={<Admin_edit_income />} />
   <Route exact path='/adminpanel-dashboard-customer-profile' element={<Admin_customer_profile />} />
   <Route exact path='/adminpanel-dashboard-edit-customer' element={<Admin_edit_customer />} />
   <Route exact path='/adminpanel-dashboard-loan-schemes' element={<Admin_loanschemes />} />
   <Route exact path='/adminpanel-dashboard-create-loanscheme' element={<Admin_create_loanscheme />} />
   <Route exact path='/adminpanel-dashboard-edit-loanscheme' element={<Admin_edit_loanscheme />} />
   <Route exact path='/admin-dashboard-customer-updations' element={<Admin_customer_updations />} />
   <Route exact path='/admin-dashboard-transaction-history' element={<Admin_transaction_history />} />
   <Route exact path='/admin-dashboard-branch' element={<Admin_branch />} />
   <Route exact path='/admin-dashboard-create-branch' element={<Admin_create_branch />} />
   <Route exact path='/admin-dashboard-edit-branch' element={<Admin_edit_branch />} />
   <Route exact path='/adminpanel-dashboard-employee-profile' element={<Admin_employee_profile />} />
   <Route exact path='/adminpanel-dashboard-add-employee' element={<Admin_add_employee />} />
   <Route exact path='/adminpanel-dashboard-edit-employee' element={<Admin_edit_employee />} />
   <Route exact path='/adminpanel-dashboard-employee-salary' element={<Admin_employee_salary />} />
   <Route exact path='/adminpanel-dashboard-create-salary' element={<Admin_create_salary />} />
   <Route exact path='/adminpanel-dashboard-customer-profile' element={<Admin_customer_profile />} />
   <Route exact path='/adminpanel-dashboard-edit-salary' element={<Admin_edit_salary />} />
   <Route exact path='/adminpanel-dashboard-customer-loans' element={<Admin_customer_loans />} />
   <Route exact path='/adminpanel-dashboard-customer-emis' element={<Admin_customer_emis /> } />
   <Route exact path='/adminpanel-dashboard-loanscheme-details' element={<Admin_loan_scheme_details />} />
   <Route exact path='/adminpanel-dashboard-view-customer-account-application' element={<Admin_view_customer_application />} />
   <Route exact path='/adminpanel-dashboard-view-loan-application' element={<Admin_view_loan_application />} />
   <Route exact path='/adminpanel-dashboard-loan-approval' element={<Admin_loan_approval />} />
   <Route exact path='/adminpanel-dashboard-view-salary' element={<Admin_view_salary />} />
   <Route exact path='/adminpanel-dashboard-view-emi' element={<Admin_view_emi />} />

    <Route exact path='/adminpanel-dashboard-settings' element={<Admin_settings />} />

   /* CUSTOMER PANEL */
   <Route exact path='/customer-login' element={<Customerlogin />} />
   <Route exact path='/customer-dashboard' element={<Customer_dashboard />} />
   <Route exact path='/customer-dashboard-profile' element={<Customer_customer_profile />} />
   <Route exact path='/customer-dashboard-loans' element={<Customer_customer_loans />} />
   <Route exact path='/customer-dashboard-emis' element={<Customer_customer_emis />} />
   <Route exact path='/customer-dashboard-updations' element={<Customer_customer_updations />} />
   <Route exact path='/customer-dashboard-emis-history' element={<Customer_customer_emis_history />} />

   /* EMPLOYEE PANEL */
   <Route exact path='/employee-login' element={<Employeelogin />} />
   <Route exact path='/employee-dashboard-cash' element={<Employee_cash />} />
   <Route exact path='/employee-dashboard-bank' element={<Employee_bank />} />
   <Route exact path='/employee-dashboard-customers' element={<Employee_customers />} />
   <Route exact path='/employee-dashboard-new-account-requests' element={<Employee_newaccounts />} />
   <Route exact path='/employee-dashboard-incomes' element={<Employee_incomes />} />
   <Route exact path='/employee-dashboard-expenses' element={<Employee_expenses />} />
   <Route exact path='/employee-dashboard-loan-payments' element={<Employee_loanpayments />} />
   <Route exact path='/employee-dashboard-loan-requests' element={<Employee_loanrequests />} />
   <Route exact path='/employee-dashboard-add-customer' element={<Employee_add_customer />} />
   <Route exact path='/employee-dashboard-edit-customer' element={<Employee_edit_customer />} />
   <Route exact path='/employee-dashboard-customer-profile' element={<Employee_customer_profile />} />
   <Route exact path='/employee-dashboard-customer-loans' element={<Employee_customer_loans />} />
   <Route exact path='/employee-dashboard-create-cash' element={<Employee_create_cash />} />
   <Route exact path='/employee-dashboard-create-bank' element={<Employee_create_bank />} />
   <Route exact path='/employee-dashboard-create-expense' element={<Employee_create_expense />} />
   <Route exact path='/employee-dashboard-create-income' element={<Employee_create_income />} />
   <Route exact path='/employee-dashboard-edit-cash' element={<Employee_edit_cash />} />
   <Route exact path='/employee-dashboard-edit-bank' element={<Employee_edit_bank />} />
   <Route exact path='/employee-dashboard-edit-expense' element={<Employee_edit_expense />} />
   <Route exact path='/employee-dashboard-edit-income' element={<Employee_edit_income />} />
   <Route exact path='/employee-dashboard-loan-schemes' element={<Employee_loanschemes />} />
   <Route exact path='/employee-dashboard-customer-updations' element={<Employee_customer_updations />} />
   <Route exact path='/employee-dashboard-transaction-history' element={<Employee_transaction_history />} />
   <Route exact path='/employee-dashboard-customer-loan-application' element={<Employee_loan_application />} />
   <Route exact path='/employee-dashboard-view-loan-application' element={<Employee_view_loan_application />} />
   <Route exact path='/employee-dashboard-customer-emis' element={<Employee_customer_emis />} />
   <Route exact path='/employee-dashboard-customer-pay-emi' element={<Employee_pay_emi />} />
   <Route exact path='/employee-dashboard-view-emi' element={<Employee_view_emi />} />
   <Route exact path='/employee-dashboard-loan-closure' element={<Employee_loan_closure />} />
   <Route exact path='/employee-dashboard-loan-closure-requests' element={<Employee_closure_requests />} />
   <Route exact path='/employee-dashboard-view-loan-closure' element={<Employee_view_closure />} />
   <Route exact path='/admin-dashboard-loan-closure-requests' element={<Admin_closure_requests />} />
   <Route exact path='/admin-dashboard-view-loan-closure' element={<Admin_view_closure />} />
   <Route exact path='/admin-dashboard-employee-offer-letter' element={<Admin_offer_letter />} />
   <Route exact path='/admin-dashboard-create-offer-letter' element={<Admin_create_offer_letter />} />
   <Route exact path='/adminpanel-dashboard-offer-letters-history' element={<Admin_offerletters_history />} />
   <Route exact path='/admin-dashboard-manage-employee-permissions' element={<Admin_manage_employee_permissions />} />
   <Route exact path='/employee-dashboard-customer-emicard' element={<Employee_customer_emicard />} />
   <Route exact path='/admin-dashboard-customer-emicard' element={<Admin_customer_emicard />} />
   <Route exact path='/admin-dashboard-loan-disbursals' element={<Admin_loandisbursals />} />
   <Route exact path='/employee-dashboard-loan-disbursals' element={<Employee_loandisbursals />} />
   <Route exact path='/employee-dashboard-disbursal-collection' element={<Employee_disbursalcollection />} />
   <Route exact path='/admin-dashboard-edit-emi' element={<Admin_edit_emi />} />
   <Route exact path='/employee-dashboard-loanscheme-details' element={<Employee_loan_scheme_details />} />
   <Route exact path='/admin-dashboard-headers' element={<Admin_headers />} />
   <Route exact path='/admin-dashboard-create-header' element={<Admin_create_header />} />
   <Route exact path='/employee-dashboard-create-partpayment-request' element={<Employee_part_payment />} />
   <Route exact path='/employee-dashboard-partpayment-requests' element={<Employee_partpayment_requests />} />
   <Route exact path='/employee-dashboard-view-partpayment' element={<Employee_view_partpayment />} />
   <Route exact path='/admin-dashboard-partpayment-requests' element={<Admin_partpayment_requests />} />
   <Route exact path='/admin-dashboard-view-partpayment' element={<Admin_view_partpayment />} />
   <Route exact path='/admin-dashboard-collections' element={<Admin_collections />} />
   <Route exact path='/employee-dashboard-collections' element={<Employee_collections />} />
   <Route exact path='/admin-dashboard-transaction-approvals' element={<Admin_transaction_approvals />} />
   <Route exact path='/admin-dashboard-loan-noc' element={<Admin_loan_noc />} />
   <Route exact path='/employee-dashboard-loan-noc' element={<Employee_loan_noc />} />
   <Route exact path='/admin-dashboard-loan-groups' element={<Admin_loangroups />} />
   <Route exact path='/admin-dashboard-group-loanrequests' element={<Admin_group_loanrequests />} />  
   <Route exact path='/employee-dashboard-loan-groups' element={<Employee_loangroups />} />
   <Route exact path='/employee-dashboard-group-loanrequests' element={<Employee_group_loanrequests />} />  
   <Route exact path='/admin-final-analysis' element={<Admin_finalanalysis />} />  
   <Route exact path='/admin-branch-final-analysis' element={<Admin_branch_finalanalysis />} />  
   <Route exact path='/admin-employee-final-analysis' element={<Admin_employee_finalanalysis />} />  
   <Route exact path='/employee-final-analysis' element={<Employee_finalanalysis />} />  


   <Route exact path='/admin-dashboard-fd-schemes' element={<Admin_fd_schemes />} />
   <Route exact path='/admin-dashboard-create-fd-scheme' element={<Admin_create_fdscheme />} />
   <Route exact path='/admin-dashboard-fdscheme-details' element={<Admin_fd_scheme_details />} />
   <Route exact path='/admin-dashboard-edit-fdscheme' element={<Admin_edit_fdscheme />} />
   <Route exact path='/employee-dashboard-fd-schemes' element={<Employee_fd_schemes />} />
   <Route exact path='/employee-dashboard-fdscheme-details' element={<Employee_fd_scheme_details />} />
   <Route exact path='/employee-dashboard-create-fd-application' element={<Employee_fd_application />} />
   <Route exact path='/employee-dashboard-fd-requests' element={<Employee_fd_requests />} />
   <Route exact path='/employee-dashboard-view-fd-application' element={<Employee_view_fd_application />} />
   <Route exact path='/admin-dashboard-fd-requests' element={<Admin_fd_requests />} />
   <Route exact path='/admin-dashboard-view-fd-application' element={<Admin_view_fd_application />} />
   <Route exact path='/admin-dashboard-fixed-deposits' element={<Admin_fixed_deposits />} />
   <Route exact path='/employee-dashboard-fixed-deposits' element={<Employee_fixed_deposits />} />
   <Route exact path='/admin-dashboard-view-fixed-deposit' element={<Admin_view_fixed_deposit />} />
   <Route exact path='/employee-dashboard-view-fixed-deposit' element={<Employee_view_fixed_deposit />} />
   <Route exact path='/employee-dashboard-create-fd-withdrawal' element={<Employee_fd_withdrawal />} />
   <Route exact path='/employee-dashboard-fd-withdrawals' element={<Employee_fd_withdrawals />} />
   <Route exact path='/employee-dashboard-view-fd-withdrawals' element={<Employee_view_fd_withdrawal />} />
   <Route exact path='/admin-dashboard-fd-withdrawals' element={<Admin_fd_withdrawals />} />
   <Route exact path='/admin-dashboard-view-fd-withdrawals' element={<Admin_view_fd_withdrawal />} />
   <Route exact path='/admin-dashboard-approve-fd-withdrawal' element={<Admin_approve_fd_withdrawal />} />
   <Route exact path='/employee-dashboard-fd-calculator' element={<Employee_fd_calculator />} />
   <Route exact path='/admin-dashboard-fd-calculator' element={<Admin_fd_calculator />} />
   
   <Route exact path='/admin-dashboard-rd-schemes' element={<Admin_rd_schemes />} />
   <Route exact path='/admin-dashboard-create-rd-scheme' element={<Admin_create_rdscheme />} />
   <Route exact path='/admin-dashboard-rdscheme-details' element={<Admin_rd_scheme_details />} />
   <Route exact path='/admin-dashboard-edit-rdscheme' element={<Admin_edit_rdscheme />} />
   <Route exact path='/employee-dashboard-rd-schemes' element={<Employee_rd_schemes />} />
   <Route exact path='/employee-dashboard-rdscheme-details' element={<Employee_rd_scheme_details />} />
   <Route exact path='/admin-dashboard-rd-maturity-amount-calculator' element={<Admin_rd_maturityamt_calculator />} />
   <Route exact path='/employee-dashboard-rd-maturity-amount-calculator' element={<Employee_rd_maturityamt_calculator />} />
   <Route exact path='/employee-dashboard-create-rd-application' element={<Employee_rd_application />} />
   <Route exact path='/employee-dashboard-rd-requests' element={<Employee_rd_requests />} />
   <Route exact path='/employee-dashboard-view-rd-application' element={<Employee_view_rd_application />} />
   <Route exact path='/admin-dashboard-rd-requests' element={<Admin_rd_requests />} />
   <Route exact path='/admin-dashboard-view-rd-application' element={<Admin_view_rd_application />} />
   <Route exact path='/employee-dashboard-recurring-deposits' element={<Employee_recurring_deposits />} />
   <Route exact path='/employee-dashboard-view-recurring-deposit' element={<Employee_view_recurring_deposit />} />
   <Route exact path='/admin-dashboard-recurring-deposits' element={<Admin_recurring_deposits />} />
   <Route exact path='/admin-dashboard-view-recurring-deposit' element={<Admin_view_recurring_deposit />} />

   <Route exact path='/employee-dashboard-rd-installment-payments' element={<Employee_installmentpayments />} />
   <Route exact path='/admin-dashboard-rd-installment-payments' element={<Admin_installmentpayments />} />
   <Route exact path='/employee-dashboard-view-rd-installment-receipt' element={<Employee_view_installment />} />
   <Route exact path='/admin-dashboard-view-rd-installment-receipt' element={<Admin_view_installment />} />
   <Route exact path='/employee-dashboard-customer-pay-rd-installment' element={<Employee_pay_rd_installment />} />
   <Route exact path='/employee-dashboard-create-rd-withdrawal' element={<Employee_rd_withdrawal />} />
   <Route exact path='/employee-dashboard-rd-withdrawals' element={<Employee_rd_withdrawals />} />
   <Route exact path='/employee-dashboard-view-rd-withdrawals' element={<Employee_view_rd_withdrawal />} />
   <Route exact path='/admin-dashboard-rd-withdrawals' element={<Admin_rd_withdrawals />} />
   <Route exact path='/admin-dashboard-view-rd-withdrawals' element={<Admin_view_rd_withdrawal />} />
   <Route exact path='/admin-dashboard-approve-rd-withdrawal' element={<Admin_approve_rd_withdrawal />} />

   <Route exact path='/admin-dashboard-customer-draft' element={<Admin_cust_lp />} />
   <Route exact path='/admin-dashboard-view-oddues' element={<Admin_oddues />} />
   <Route exact path='/employee-dashboard-view-oddues' element={<Employee_oddues />} />

   <Route exact path='/employee-dashboard-topup-loanclosure' element={<Employee_topup_loanclosure />} />
   <Route exact path='/employee-dashboard-topup-loanclosure-requests' element={<Employee_topup_loan_closure_requests />} />
   <Route exact path='/admin-dashboard-topup-loanclosure-requests' element={<Admin_topup_loan_closure_requests />} />
   <Route exact path='/employee-dashboard-loan-topup' element={<Employee_loan_topup />} />
   <Route exact path='/employee-dashboard-topup-loan-requests' element={<Employee_topup_loan_requests />} />
   <Route exact path='/admin-dashboard-topup-loan-requests' element={<Admin_topup_loan_requests />} />
   

   //UPLOAD DOCUMENTS TO DRIVE
   <Route exact path='/employee-dashboard-uploadtodrive' element={<Employee_drive1 />} />


   <Route exact path='/employee-dashboard-update-adr-number' element={<Employee_test_emp_adr />} />


   //NEW ROUTES BEING CREATED
    <Route exact path='/admin-dashboard-view-new-oddues' element={<Admin_newoddues />} />
    <Route exact path='/employee-dashboard-view-new-oddues' element={<Employee_new_oddues />} />
    <Route exact path='/admin-dashboard-view-today-collections' element={<Admin_daily_collections />} />
    <Route exact path='/employee-dashboard-view-today-collections' element={<Employee_daily_collections />} />

    <Route exact path='/employee-dashboard-customer-loan-application-prefill' element={<Employee_loan_application_prefill />} />
    <Route exact path='/admin-dashboard-groups-list' element={<Admin_loangroupslist />} />
    <Route exact path='/admin-dashboard-create-loan-group' element={<Admin_create_group />} />

    <Route exact path='/admin-dashboard-daysummarylist' element={<Admin_daysummarylist />} />
    <Route exact path='/admin-dashboard-daysummary' element={<Admin_daysummary />} />

    <Route exact path='/employee-dashboard-daysummarylist' element={<Employee_daysummarylist />} />
    <Route exact path='/employee-dashboard-daysummary' element={<Employee_daysummary />} />

    <Route exact path='/employee-dashboard-manage-daycash' element={<Employee_day_cash />} />
    <Route exact path='/employee-dashboard-pay-collection' element={<Employee_pay_collection />} />

    <Route exact path='/superadmin-dashboard-transaction-approvals' element={<Superadmin_transaction_approvals />} />


    //DASHBOARD ROUTES
    <Route exact path='/employee-dashboard' element={<Employee_dashboard />} />
    <Route exact path='/admin-dashboard' element={<Admin_dashboard />} />
    <Route exact path='/admin-loanscheme-calculator' element={<Admin_loanscheme_calculator />} />

   </Routes>
   </Router>
</>
    );


}

export default Routestosite;